/*global __CLIENT__*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Map } from 'immutable';
import ContextMenu from './contextMenus/organizationContext';
import { OrganizationActions } from '../../actions/organization';
import OrganizationCardSummary from '../../components/OrganizationCardSummary';

import '../../styles/ProjectCardSummary.css';

export default class OrganizationCard extends PureComponent {
  static propTypes = {
    organization: PropTypes.instanceOf(Map).isRequired,
    user: PropTypes.instanceOf(Map),
    currentUser: PropTypes.instanceOf(Map),
  };

  setOrgId = () => {
    const { dispatch, organization } = this.props;
    dispatch(OrganizationActions.setOrganizationId(organization.get('id')));
  }

  render() {
    const { organization, user, currentUser, userMode, dispatch } = this.props;
    if (!organization) {
      return null;
    }

    const description = organization.get('description');
    // const userCount = organization.getIn(['counts', 'users']);
    const projectCount = organization.getIn(['counts', 'projects']);
    const accountCount = organization.getIn(['counts', 'accounts']);
    // const elementCount = organization.getIn(['counts', 'elements']);
    // const elementTypeCount = organization.getIn(['counts', 'element_types']);
    const creator = user
      ? user.get('first_name') + ' ' + user.get('last_name')
      : '';
    const createdAt = organization.get('created_at');

    return (
      <div className="card project-card">
        <div className="card-context" style={{ position: 'absolute', right: 0 }}>
          <ContextMenu
            dispatch={dispatch}
            organization={organization}
            // organizationId={organizationId}
            currentUser={currentUser}
            userMode={userMode}
          />
        </div>
        <div className="card-body project-header">
          <h3 className="project-name">
            <Link onClick={this.setOrgId} to={`/organizations/${organization.get('id')}`}>
              {organization.get('name')}
            </Link>
          </h3>
        </div>
        <OrganizationCardSummary
          description={description}
          projectCount={projectCount}
          accountCount={accountCount}
          creator={creator}
          createdAt={createdAt}
        />
          {/* userCount={userCount}
          elementCount={elementCount}
          elementTypeCount={elementTypeCount} */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/OrganizationCard.js